import { accordionInit } from './modules/accordion.js';
import { equalHeightsInit } from './modules/equalHeights.js';
import { headerInit } from './modules/header.js';
import { menuInit } from './modules/menu.js';
import { openDocsInit } from './modules/docs.js';
import { scrollInit } from './modules/scrollReveal.js';
import { slickInit } from './modules/slick.js';
import { slideshowInit } from './modules/slideshow.js';
import { socialInit } from './modules/social.js';
import { searchInit } from './modules/search.js';
import { videoInit } from './modules/video.js';
import { viewsInit } from './modules/views.js';
import { DonationInit } from './donation.js';

window.Unicef = {
    init: function() {
        // Initialize all modules
        accordionInit();
        equalHeightsInit();
        headerInit();
        menuInit();
        scrollInit();
        slideshowInit();
        socialInit();
        slickInit();
        openDocsInit();
        videoInit();
        viewsInit();
        searchInit();
        DonationInit();
    }
};

window.Unicef.init();
